import { Schema as Schema$1, DeprecatedDefaultSchema } from "./_chunks-es/Schema.js";
import { DEFAULT_ANNOTATIONS, DEFAULT_DECORATORS, Rule } from "./_chunks-es/Schema.js";
const Schema = Schema$1;
export {
  DEFAULT_ANNOTATIONS,
  DEFAULT_DECORATORS,
  Rule,
  Schema,
  DeprecatedDefaultSchema as default
};
//# sourceMappingURL=index.js.map
